import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { WarehouseOwnerDetails } from '../models/warehouse-owner-details';
import { Guid } from '@web/utils';
import { WarehouseOwnerDataSourceService } from '../services/warehouse-owner-data-source.service';

@Pipe({
  name: 'fetchWarehouseOwnerById',
  standalone: true,
})
export class FetchWarehouseOwnerByIdPipe implements PipeTransform {
  /* prettier-ignore */
  private readonly warehouseOwnerDataSource = inject(WarehouseOwnerDataSourceService);

  public transform(id: Guid): Observable<WarehouseOwnerDetails> {
    return this.warehouseOwnerDataSource.fetchDetailsById(id, true);
  }
}
